type MetaPixelPayload = Record<string, unknown>

declare global {
  interface Window {
    fbq?: (...args: unknown[]) => void
    _fbq?: (...args: unknown[]) => void
  }
}

const getFbq = () => {
  if (typeof window === 'undefined') return null
  const fbq = window.fbq ?? window._fbq
  if (typeof fbq !== 'function') return null
  return fbq
}

export const trackMetaPixel = (event: string, payload?: MetaPixelPayload) => {
  const fbq = getFbq()
  if (!fbq) return
  if (payload) {
    fbq('track', event, payload)
    return
  }
  fbq('track', event)
}
